var render = function render(){var _vm=this,_c=_vm._self._c;return _c('agent-default',[_c('travel-plan-select-page',{attrs:{"channel":"agent"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }